import React from "react";

const Workflows = () => {
    return (
        <>
            This is Workflows Page
        </>
    );
};

export default Workflows;
